<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("view") }} {{ $tc("weekwiseContract", 2) }}
      </div>
      <div>
        <button class="btn-blue" @click.prevent.stop="goToRoute">
          {{ $t("edit") }}
        </button>
        <router-link class="btn-blue" to="weekwise-contract"
          >{{ $tc("weekwiseContract", 2) }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("contract", 2) }} {{ $tc("weekwise") }}
                {{ $tc("name", 2) }} 
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ contract_weekwise_name }}
              </div>
            </div>
          </div>

          <table class="table table-striped">
            <thead>
              <tr>
                <th>{{ $t("week") }}</th>
                <th>{{ $t("Contract") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(WeekwiseContract,
                WeekwiseContractsIndex) in WeekwiseContracts"
                :key="WeekwiseContractsIndex"
              >
                <td>{{ WeekwiseContract.contract_week.name }}</td>
                <td>{{ WeekwiseContract.contract_id.contract_name }}</td>
              </tr>
            </tbody>
          </table>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("status", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ contracts_by_weekwise_is_active == "Y" ? $t("active") : "" }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("createdby") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ created_by }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("createdat") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ created_at | dateparse }}</span>
                <!-- <span>12:05 AM</span> -->
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("modifiedby") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span>{{ updated_by }}</span>
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("modifiedat") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                <span class="mr-3">{{ updated_at | dateparse }}</span>
                <!-- <span>12:05 AM</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DistributorService from "@/services/DistributorService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      contract_weekwise_name: null,
      cbw_common_code: null,
      contracts_by_weekwise_is_active: "",
      created_by: null,
      created_at: null,
      updated_at: null,
      updated_by: null,
      ms_contracts: [],
      weekArray: [
        {
          name: "Week 0",
          value: 0
        },
        {
          name: "Week 1",
          value: 1
        },
        {
          name: "Week 2",
          value: 2
        },
        {
          name: "Week 3",
          value: 3
        },
        {
          name: "Week 4",
          value: 4
        },
        {
          name: "Week 5",
          value: 5
        },
        {
          name: "Thereafter",
          value: -1
        }
      ],
      selectedContract: "Select Contract Type",
      selectedWeek: "Select Week",
      WeekwiseContracts: [
        // {
        //   contract_week: "",
        //   contract_id: ""
        // }
      ]
    };
  },
  mounted() {
    this.cbw_common_code = this.$route.query.cbw_common_code;
    if (this.cbw_common_code) {
      this.getActiveContracts();
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    goToRoute: function() {
      this.$router.push({
        path: "/distributor/edit-weekwise-contract",
        query: {
          cbw_common_code: this.cbw_common_code
        }
      });
    },
    getContractWeekwiseDetails: function() {
      let payload = {
        cbw_common_code: this.cbw_common_code
      };
      DistributorService.GetSingleContractByWeekWiseDetails(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            this.contract_weekwise_name = obj.contract_weekwise_name;
            this.created_at = obj.created_at;
            this.updated_at = obj.updated_at;
            this.contracts_by_weekwise_is_active =
              obj.contracts_by_weekwise_is_active;
            this.getViewUsersDetails(obj.created_by, "created_by");
            this.getViewUsersDetails(obj.updated_by, "updated_by");
            data.Records.map(x => {
              let weekArray = this.weekArray.filter(y => {
                return x.contract_week == y.value;
              });
              let contractArray = this.ms_contracts.filter(y => {
                return x.contract_id == y.contract_id;
              });
              this.WeekwiseContracts.push({
                cbw_id: x.cbw_id,
                contract_week: weekArray[0],
                contract_id: contractArray[0]
              });
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getActiveContracts: function() {
      let payload = {
        tableName: "ms_contracts",
        contract_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ms_contracts = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(async () => {
          await this.getContractWeekwiseDetails();
        }); //message
    },
    getViewUsersDetails(user_id, fieldvalue) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[fieldvalue] = data.Records[0].user_name;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/WeekWiseContractComponents/viewWeekwiseContract.vue